var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerWave2Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.412c0-.89-1.077-1.337-1.707-.707l-4 4a1 1 0 01-.707.293H5a2 2 0 00-2 2v4a2 2 0 002 2h1.586a1 1 0 01.707.293l4 4c.63.63 1.707.183 1.707-.707V4.412z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.24 8.347a1 1 0 011.41-.109c1.109.95 1.85 2.26 1.85 3.76 0 1.499-.741 2.81-1.85 3.76a1 1 0 01-1.3-1.52c.758-.65 1.15-1.439 1.15-2.24 0-.802-.392-1.59-1.15-2.24a1 1 0 01-.11-1.41z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.323 5.262a1 1 0 011.413.059c1.72 1.87 2.764 4.167 2.764 6.677s-1.044 4.806-2.764 6.676a1 1 0 11-1.472-1.353c1.44-1.566 2.236-3.396 2.236-5.323 0-1.927-.797-3.757-2.236-5.324a1 1 0 01.06-1.412z",
    fill: "currentColor"
  })));
}
export default SvgSpeakerWave2Fill;